import { Icon, IconProps } from '@mui/material';

import Slack_Logo from '../../../assets/images/Slack_Mark.svg';
import Slack_Logo_Black from '../../../assets/images/Slack_Mark_Black.svg';

function SlackLogo(props: IconProps) {
    return (
        <Icon {...props}>
            <img src={Slack_Logo} />
        </Icon>
    );
}

function SlackLogoBlack(props: IconProps) {
    return (
        <Icon {...props}>
            <img src={Slack_Logo_Black} />
        </Icon>
    );
}

export { SlackLogo, SlackLogoBlack };
